import React from 'react';
import { Typewriter } from 'react-simple-typewriter';
import { Link } from 'react-router-dom';
import '../CSS/HighlightSection.css';
import { useTranslation } from 'react-i18next';

function HighlightSection() {
  const { t, i18n } = useTranslation();
  
  // Get the words array directly from the i18n resources
  const getTypewriterWords = () => {
    const currentLanguage = i18n.language;
    if (currentLanguage === 'fi') {
      return [
        'ohjelmoinnissa',
        'web-kehityksessä',
        'pelikehityksessä',
        'UI-suunnittelussa',
        'minecraftissa'
      ];
    } else {
      return [
        'programming',
        'web development',
        'game development',
        'UI design',
        'Minecraft'
      ];
    }
  };
  
  const words = getTypewriterWords();
  
  return (
    <div className="highlight-wrapper mt-5">
      <h2 className="highlight-heading">
        {t('HighlightSection.title')}<br></br>{' '}
        <span className="typewriter-text">
          <Typewriter
            words={words}
            loop={0}
            cursor
            cursorStyle="_"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </span>
      </h2>

      <p className="highlight-subtext mt-3">
        {t('HighlightSection.subtext')}
        <Link to="/projects" className="highlight-link">{t('HighlightSection.link')}</Link>
      </p>
    </div>
  );
}

export default HighlightSection;
